import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import FormDrawer from "src/components/Form/FormDrawer";
import { useAppSelector } from "src/store";
import { createSupplierTypeSaga } from "src/store/supplier-types/saga";
import * as Yup from "yup";

const SupplierTypeCreateForm = ({
  onHide,
  open,
  onSuccessClick,
}: {
  onSuccessClick: (message: string) => void;
  onHide: () => void;
  open: boolean;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const languages = useAppSelector((s) => s.language.languages);

  return (
    <React.Fragment>
      <FormDrawer
        drawerProps={{
          isOpen: open,
          onHide: onHide,
          title: t("SupplierType.CreateFormTitle").toString(),
        }}
        onHide={onHide}
        loader
        initialValues={{
          Name: "",
          Translates: languages.map((x) => {
            return { LanguageId: x.EnumId, Name: "" };
          }),
        }}
        validationSchema={Yup.object().shape({
          Name: Yup.string().required(t("Validation.Required").toString()),

          Translates: Yup.array(
            Yup.object({
              Name: Yup.string().required(t("Validation.Required").toString()),
            })
          ),
        })}
        multilanguageinputs={[
          {
            field: "Name",
            label: t("SupplierType.Name").toString(),
          },
        ]}
        onSubmit={(values) => {
          dispatch(
            createSupplierTypeSaga({
              payload: {
                onSuccess: (message, payload) => {
                  onHide();
                  onSuccessClick(message);
                },
                onError: (message) => {
                  toast.error(message, {
                    theme: "colored",
                  });
                },
              },
              body: values,
            })
          );
        }}
      />
    </React.Fragment>
  );
};
export default SupplierTypeCreateForm;
